"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentProps = void 0;
const React = require("react");
// tslint:disable:variable-name
const ComponentProps = ({ properties = [] }) => {
    return (React.createElement("div", { style: { fontSize: 'x-small' } },
        React.createElement("h4", null, "Component properties"),
        React.createElement("ul", null, properties.map((prop) => (React.createElement("li", null, `${prop.name}${prop.type ? ': ' + prop.type.name : ''}`))))));
};
exports.ComponentProps = ComponentProps;
//# sourceMappingURL=ComponentProps.js.map